import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import JSZip from 'jszip';
import ReactDOM from 'react-dom';
import { hot } from 'react-hot-loader/root';
import App from './views/layout/App';
import i18n from '@Lang/i18n';

import '@toast-ui/editor/dist/toastui-editor.css';

import "@Scss/Common.scss";
import "@Scss/Header.scss";
import "@Scss/Footer.scss";
import "@Scss/Body.scss";
import "@Scss/Media.scss";
import "@Scss/Grid.scss";
import "@Scss/new.scss";
import "@Scss/employment.scss"

const Hot = hot(App);
const win: any = window;
win.JSZip = JSZip;

const lang = 'ko';
i18n.changeLanguage(lang);
localStorage.setItem("lang", lang);

ReactDOM.render(
  <Hot />,
  document.getElementById('root')
);
